import React from "react";
import QueueAnim from 'rc-queue-anim';
import './style.less'
import {Card, Row, Col} from 'antd';

const {Meta} = Card;

export default class MobileParametersContent extends React.Component {

    render() {
        return (
            <div className="mobile-gimbal-description-container">
                <div className="description">
                    <div className='line'>
                        <Row>
                        <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/006.png" alt={""}/>
                                    </div>
                                    <div className="line-box-item" style={{ 'width': 'max-content' }}>
                                        <p>8mm星光相机<br />更好的夜视能力</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                        <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/007.png" alt={""} />
                                    </div>
                                    <div className="line-box-item">
                                        <p>30倍高清无损变焦<br />1080p</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/003.png" alt={""}/>
                                    </div>
                                    <div className="line-box-item">
                                        <p>具有灰度和<br />彩色模式的热成像</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                        <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/002.png" alt={""} />
                                    </div>
                                    <div className="line-box-item">
                                        <p>强大的目标跟踪能力</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                        <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/001.png" alt={""} />
                                    </div>
                                    <div className="line-box-item">
                                        <p>高精度测距</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/004.png" alt={""}/>
                                    </div>
                                    <div className="line-box-item">
                                        <p>三轴增稳</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="12" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                        <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/005.png" alt={""} />
                                    </div>
                                    <div className="line-box-item">
                                        <p>自动跟踪和监视目标</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

        )

    }
}
